export default __webpack_public_path__ + "static/media/google-g-logo-disabled.2133c790.svg";